import API_BASE_URL from '../config';

const isAbsoluteUrl = (url) => /^https?:\/\//i.test(url);
const isDataOrBlob = (url) => /^(data:|blob:)/i.test(url);

const safeUrl = (value) => {
  if (!value || typeof value !== 'string') return '';
  return value.trim();
};

export const resolveImageUrl = (src) => {
  const cleanSrc = safeUrl(src);
  if (!cleanSrc) return '';
  if (isDataOrBlob(cleanSrc) || isAbsoluteUrl(cleanSrc)) return cleanSrc;

  const base = API_BASE_URL.replace(/\/+$/, '');
  const path = cleanSrc.startsWith('/') ? cleanSrc : `/${cleanSrc}`;
  return `${base}${path}`;
};

const optimizeCloudinaryUrl = (url, { width = 800, quality = 75 } = {}) => {
  if (!url.includes('/upload/')) return url;
  const transform = `f_auto,q_auto:${quality},c_limit,w_${width}`;
  return url.replace('/upload/', `/upload/${transform}/`);
};

const optimizeGenericUrl = (url, { width = 800, quality = 75, format = 'webp' } = {}) => {
  try {
    const parsed = new URL(url);
    const apiHost = new URL(API_BASE_URL).hostname;
    const knownHost =
      parsed.hostname === apiHost ||
      parsed.hostname.includes('cloudinary.com') ||
      parsed.hostname.includes('imgix.net');

    if (!knownHost) return url;

    if (parsed.hostname.includes('imgix.net')) {
      parsed.searchParams.set('auto', 'format');
      parsed.searchParams.set('fit', 'max');
      parsed.searchParams.set('w', String(width));
      parsed.searchParams.set('q', String(quality));
      return parsed.toString();
    }

    parsed.searchParams.set('format', format);
    parsed.searchParams.set('quality', String(quality));
    parsed.searchParams.set('width', String(width));
    return parsed.toString();
  } catch {
    return url;
  }
};

export const getOptimizedImageUrl = (src, options = {}) => {
  const resolved = resolveImageUrl(src);
  if (!resolved) return '';
  if (isDataOrBlob(resolved)) return resolved;

  if (resolved.includes('res.cloudinary.com')) {
    return optimizeCloudinaryUrl(resolved, options);
  }

  return optimizeGenericUrl(resolved, options);
};

export const setOptimizedImageFallback = (event, originalSrc, placeholder = '/images/placeholder.jpg') => {
  const target = event.target;
  const original = resolveImageUrl(originalSrc);
  const fallback = resolveImageUrl(placeholder);

  if (!target.dataset.originalTried && original) {
    target.dataset.originalTried = 'true';
    target.src = original;
    return;
  }

  target.src = fallback || placeholder;
};
